import type { SVGProps } from 'react';
const copyOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.75 3H18.75C19.9926 3 21 4.00736 21 5.25V14.25C21 15.4926 19.9926 16.5 18.75 16.5H17.25V15H18.75C19.1642 15 19.5 14.6642 19.5 14.25V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5H9.75C9.33579 4.5 9 4.83579 9 5.25V6.75H7.5V5.25C7.5 4.00736 8.50736 3 9.75 3Z"
      fill={props.color ?? 'black'}
    />
    <path
      clipRule="evenodd"
      d="M16.5 9.75C16.5 8.50736 15.4926 7.5 14.25 7.5H5.25C4.00736 7.5 3 8.50736 3 9.75V18.75C3 19.9926 4.00736 21 5.25 21H14.25C15.4926 21 16.5 19.9926 16.5 18.75V9.75ZM14.25 9C14.6642 9 15 9.33579 15 9.75V18.75C15 19.1642 14.6642 19.5 14.25 19.5H5.25C4.83579 19.5 4.5 19.1642 4.5 18.75V9.75C4.5 9.33579 4.83579 9 5.25 9H14.25Z"
      fill={props.color ?? 'black'}
      fillRule="evenodd"
    />
  </svg>
);
export default copyOutline;
